import React, { FC } from 'react';

import { PrioridadeSelect } from 'view/component/Prioridade/PrioridadeSelect';

import { UnidadeSelect } from 'view/component/UnidadeSelect/UnidadeSelect';
import { SolicitacaoDetalhada } from 'model/solicitacao/SolicitacaoDetalhada';
import { ResponsavelTecnicoSelect } from 'view/component/ResponsavelTecnicoSelect/ResponsavelTecnicoSelect';
import { SituacaoSelect } from 'view/component/Situacao/SituacaoSelect';
import { Label } from 'view/component/Label/Label';
import { ServidorField } from 'view/component/ServidorField/ServidorField';
import { MensagemErro } from 'view/component/Formulario/MensagemErro/MensagemErro';
import styled from 'styled-components';
import { AvaliacaoInfo } from 'view/component/Avaliacao/AvaliacaoInfo';
import { Situacoes } from 'model/solicitacao/Situacao';
import { If } from 'view/component/Utils/If';


interface SolicitacaoFormularioContextoProps {
  solicitacao: SolicitacaoDetalhada
}

export const SolicitacaoFormularioContexto: FC<SolicitacaoFormularioContextoProps> = ({solicitacao}) => {
  const isFechada = solicitacao.situacao.id === Situacoes.FECHADO.id;

  return <Container className="row form-horizontal">

    <If condicao={isFechada}>
      <Label className="col-xs-4" htmlFor="avaliacao">Nota da Avaliação</Label>
      <div className="col-xs-8">
        <AvaliacaoInfo name="avaliacao" solicitacao={solicitacao} />
      </div>
    </If>

    <Label className="col-xs-4" htmlFor="situacao.id">Situação</Label>
    <SituacaoSelect name="situacao.id" className="col-xs-8" inputId="situacao.id" situacao={solicitacao.situacao} todas={false} />

    <Label className="col-xs-4" htmlFor="prioridade.id">Prioridade</Label>
    <PrioridadeSelect name="prioridade.id" className="col-xs-8" inputId="prioridade.id" />

    <Label className="col-xs-4" htmlFor="idSolicitante">Solicitante</Label>
    <ServidorField name="idSolicitante" className="col-xs-8" inputId="idSolicitante" />
    <MensagemErro className="col-xs-offset-4 col-xs-8" name="idSolicitante" />

    <Label className="col-xs-4" htmlFor="unidadeResponsavel.id">Unidade responsável</Label>
    <div className="col-xs-8">
      <UnidadeSelect name="unidadeResponsavel.id" inputId="unidadeResponsavel.id" />
    </div>

    <Label className="col-xs-4" htmlFor="responsavelTecnico.id">Responsável técnico</Label>
    <div className="col-xs-8">
      <ResponsavelTecnicoSelect
        name="responsavelTecnico.id"
        inputId="responsavelTecnico.id" />
    </div>

  </Container>;
}


const Container = styled.div`
  .select {
    display: grid;
    align-items: center;
    grid-auto-flow: column;
  }
`;